"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormGrid = void 0;
var _mui = require("@ori-ui/mui");
const FormGrid = exports.FormGrid = (0, _mui.styled)('form')(({
  theme
}) => ({
  display: 'grid',
  rowGap: theme.spacing(3)
}));
